export const loginMethods: (
	| 'email'
	| 'sms'
	| 'google'
	| 'wallet'
	| 'discord'
)[] = ['email', 'sms', 'google', 'wallet', 'discord'];
